import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { PATH, ROUTE } from '../../../../../constants';
import { getHash } from '../../../../../api';
import './KvIntro.css';

// NOTE - size values related to Content + SideMenu
const SCROLL_OFF = 50; // fow scrollbar fix (clientWidth is different than max-width in css)
const LIMITS = [2000 - SCROLL_OFF, 1700 - SCROLL_OFF];
const HEIGHT = [1200, 1000, 850];
const BG_W = 2590;
const BG_H = 1776;

class KvIntro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bgW: 0,
      bgH: 0,
      bgTop: 0,
      bgLeft: 0,
    };

    this.homeRef = React.createRef();

    this.handleResize = this.handleResize.bind(this);
  }

  // -----------------------------------------------------------------------------------
  // Lifecycle
  // -----------------------------------------------------------------------------------

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // -----------------------------------------------------------------------------------
  // Resize
  // -----------------------------------------------------------------------------------

  handleResize() {
    this.sizeUpdate();
    setTimeout(() => {
      // second 'sure' update because of layout anims
      this.sizeUpdate();
    }, 300);
  }

  sizeUpdate() {
    const docW = Number(document.documentElement.clientWidth);

    // get width
    const width = this.homeRef.current.clientWidth;

    // get height
    let height = HEIGHT[2];
    if (docW > LIMITS[0]) {
      height = HEIGHT[0]; // eslint-disable-line prefer-destructuring
    } else if (docW > LIMITS[1]) {
      height = HEIGHT[1]; // eslint-disable-line prefer-destructuring
    }

    // calc bg size + pos
    let sMain = 0;
    const sW = width / BG_W;
    const sH = height / BG_H;

    if (sW > sH) {
      sMain = sW;
    } else {
      sMain = sH;
    }

    const rW = BG_W * sMain;
    const rH = BG_H * sMain;
    this.setState({
      bgW: rW,
      bgH: rH,
      bgLeft: -(rW - width) * 0.5,
      bgTop: -(rH - height) * 0.5,
    });
  }

  // -----------------------------------------------------------------------------------
  // Render
  // -----------------------------------------------------------------------------------

  render() {
    const { bgW, bgH, bgTop, bgLeft } = this.state;

    const bgStyle = {
      width: bgW,
      height: bgH,
      top: bgTop,
      left: bgLeft,
    };

    return (
      <div id="kv-intro" ref={this.homeRef}>
        <div id="kv-intro-bg-wrap" style={bgStyle}>
          <img
            className="kv-intro-bg-image"
            alt=""
            src={`${PATH.IMG}vary/intro-bg.jpg`}
          />
        </div>
        <div id="logo-bottom-wrap">
          <img src={`${PATH.IMG}vary/intro-logo-bottom.png`} alt="" />
        </div>
        <div id="top-logos-wrap">
          <img src={`${PATH.IMG}vary/logo-kv.png`} alt="Karlovy Vary" />
        </div>
        <div id="kv-box-wrap">
          <div id="kv-box">
            <img id="re-logo" src={`${PATH.IMG}vary/intro-logo.png`} alt="" />
            <div id="kv-video-wrap">
              <iframe
                title="Intro"
                id="kv-video"
                src={`${PATH.FRAME}?hash=${getHash()}&bonus=41234&origin=noads`}
                allowFullScreen
              />
            </div>
            <p>
              Útržky paměti jednotlivých postav filmu skládají obraz okupace
              Československa v roce 1968. A také toho, co v nás tento okamžik
              zanechal.
            </p>
            <p>Sledujte nás na:</p>
            <a
              href="https://www.kviff.com/cs/program/film/57/33440-rekonstrukce-okupace"
              target="_blank"
              rel="noopener noreferrer"
            >
              MFF Karlovy Vary
              <br />
              20.-28.8.2021
            </a>
            <div id="social-ico-box">
              <a
                className="social-link"
                href="https://www.facebook.com/Rekonstrukceokupace"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="normal" src={`${PATH.IMG}vary/fb.png`} alt="" />
                <img
                  className="hover"
                  src={`${PATH.IMG}vary/fb-hover.png`}
                  alt=""
                />
              </a>
              <a
                className="social-link"
                href="https://www.instagram.com/rekonstrukce_okupace/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="normal"
                  src={`${PATH.IMG}vary/insta.png`}
                  alt=""
                />
                <img
                  className="hover"
                  src={`${PATH.IMG}vary/insta-hover.png`}
                  alt=""
                />
              </a>
            </div>
            <Link to={ROUTE.ABOUT}>
              <img
                id="box-close"
                src={`${PATH.IMG}vary/intro-close.png`}
                alt=""
              />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default KvIntro;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/KvIntro/KvIntro.js